const params = new URLSearchParams(window.location.search);
const admin = params.get("admin") || localStorage.getItem("admin");

if (admin === "true" || admin === "false") {
	localStorage.setItem("admin", admin);

	if (admin === "true") {
		document.body.dataset.admin = "true";
	}
}

if (document.body.dataset.admin === "true") {
	document.querySelectorAll("[data-admin-stock]").forEach(function (container) {
		const sku = container.dataset.sku;
		if (!sku) return;

		fetch("https://trydeapi.daxmedia.eu/v1/getStatusById.php?id=" + encodeURIComponent(sku))
			.then(function (response) {
				return response.json();
			})
			.then(function (data) {
				const values = Object.values(data).map(function (value) {
					return parseInt(value, 10);
				});
				const departmentValues = { 1: values[0], 2: values[1], 3: values[3] };

				Object.keys(departmentValues).forEach(function (dept) {
					const row = container.querySelector('[data-admin-dept="' + dept + '"]');
					const dot = row && row.querySelector(".status-inner-circle");
					if (!dot) return;
					dot.setAttribute("fill", departmentValues[dept] > 0 ? "#06ba63" : "#BA0A06");
				});
			})
			.catch(function () {});
	});
}
